import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

interface CustomToastProps {
  message: string;
  type: 'success' | 'error';
}

const CustomToast = ({ message, type }: CustomToastProps) => {
  return (
    <div>
      <ToastContainer />
    </div>
  );
};

export default CustomToast;
